import { render, staticRenderFns } from "./ReservarCitaAdmin.vue?vue&type=template&id=75faad5f&scoped=true"
import script from "./ReservarCitaAdmin.vue?vue&type=script&lang=js"
export * from "./ReservarCitaAdmin.vue?vue&type=script&lang=js"
import style0 from "./ReservarCitaAdmin.vue?vue&type=style&index=0&id=75faad5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75faad5f",
  null
  
)

export default component.exports